var FactionsById = {
  500001: "caldari",
  500002: "minmatar",
  500003: "amarr",
  500004: "gallente",
  500010: "guristas",
  500011: "angel"
};
var FactionsByName = {
  caldari: 500001,
  minmatar: 500002,
  amarr: 500003,
  gallente: 500004,
  guristas: 500010,
  angel: 500011
};
export { FactionsById, FactionsByName };